module.exports = {
  ARROW_SPEED: 35, // tiles per second
  THROWN_SPEED: 11.2, // tiles per second
  KNOCKBACK_SPEED: 7.3, // tiles per second
};
